// extracted by mini-css-extract-plugin
export var infoItem = "_ti-2";
export var title = "_ti-0";
export var value = "_ti-1";